import React from "react";
import EngagementSessionListPage from "./EngagementSessionListPageSwitch";
import { fetchRecommendedList, replaceRecommendedList } from "../../../actions/sessionListsActions";

const EngagementRecommendedListPage = () => (
  <EngagementSessionListPage
    title="Recommended Sessions"
    subtitle="No Interests Selected"
    description="Manage the ordered list of sessions shown in the Recommended carousel for users without interests selected. Drag to reorder, remove with the trash icon, then click Save changes to publish."
    sliceName="recommended_list"
    fetchList={fetchRecommendedList}
    replaceList={replaceRecommendedList}
  />
);

export default EngagementRecommendedListPage;
